import * as React from 'react';
import { AssetCheckboxClientGroupCheckbox } from './AssetCheckboxClientGroupCheckbox';
import { AssetShareTargetCheckbox } from './AssetShareTargetCheckbox';
import { AssetShareTargetGroup } from './types';

type AssetCheckboxClientGroupProps = {
    client: AssetShareTargetGroup;
    selected: ReadonlyArray<string>;
    disabled: ReadonlyArray<string>;
    onChange: (selected: string[]) => void;
};

export const AssetCheckboxClientGroup: React.FC<AssetCheckboxClientGroupProps> = ({
    client,
    disabled,
    onChange,
    selected,
}) => {
    /*
     * To save on some calculations and looping through data, let's calculate all these values
     * while rendering the location checkboxes.
     */
    let areAllLocationsChecked = true;
    let isAtLeastOneLocationChecked = false;
    let areAllLocationsDisabled = true;

    const children = client.items.map(location => {
        const isChecked = selected.includes(location.id);
        areAllLocationsChecked &&= isChecked;
        isAtLeastOneLocationChecked ||= isChecked;
        areAllLocationsDisabled &&= disabled.includes(location.id);
        return (
            <AssetShareTargetCheckbox
                disabled={disabled}
                item={location}
                key={location.id}
                selected={selected}
                style={{ paddingLeft: '8px' }}
                onChange={onChange}
            />
        );
    });
    return (
        <>
            <AssetCheckboxClientGroupCheckbox
                areAllLocationsChecked
                areAllLocationsDisabled={areAllLocationsDisabled}
                client={client}
                disabled={disabled}
                isAtLeastOneLocationChecked={isAtLeastOneLocationChecked}
                selected={selected}
                onChange={onChange}
            />
            {children}
        </>
    );
};
AssetCheckboxClientGroup.displayName = 'AssetCheckboxClientGroup';
